"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndoIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const UndoIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "23", height: "18", viewBox: "0 0 23 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9.92087 16.5291C11.434 16.5291 14.4209 16.5291 15.9209 16.5291C18.9209 16.5291 21.4209 14.2276 21.4209 11.0291C21.4209 7.66442 18.5653 5.49825 15.9209 5.52911C14.4207 5.54661 12.2115 5.52103 10.5005 5.52942C8.26367 5.54039 5.13158 5.4707 2 5.4707M2 5.4707L6.92106 1M2 5.4707C3.78947 7.11776 5.57895 8.82354 6.92106 10.0588", stroke: color !== null && color !== void 0 ? color : theme.colors.grey90, strokeWidth: "2" }) })));
};
exports.UndoIcon = UndoIcon;
//# sourceMappingURL=undo_icon.js.map